import api from ".";
import cookiesModifier from "../utils/cookies";

import { IProgramFunction } from "../types/program_function";

export const createProgramFunction = async (data: IProgramFunction) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`program-functions`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const updateProgramFunction = async (data: IProgramFunction) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.patch(`program-functions/${data.id}`, data);
        return res.status;
    } catch (error) {
        throw error;
    }
}


export const deleteProgramFunction = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.delete(`program-functions/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}

export const duplicateProgramFunction = async (id: number) => {
    const token = cookiesModifier.getCookie(process.env.REACT_APP_AUTH_TOKEN_NAME as string)
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    try {
        const res = await api.post(`program-functions/duplicate/${id}`);
        return res.status;
    } catch (error) {
        throw error;
    }
}